import { FormulaType } from '../../constants/formulaType';

import { FormulaCategory, FormulaQueryParam } from '../../models/formula.model';
import { TestMessageFilter } from 'models/message-content.model';

const formulaKeys = {
    all: ['formulas'] as const,
    formulaById: (formulaId: number) => [...formulaKeys.all, formulaId],
    approvedFormulaById: (formulaId: number, message_content_id?: string) => [
        ...formulaKeys.all,
        'approved',
        formulaId,
        message_content_id,
    ],
    formulaMessages: (
        formulaId: number,
        message_content_id?: string,
        preview_count: number = 10,
        filters?: TestMessageFilter,
    ) => [
        ...formulaKeys.formulaById(formulaId),
        'messages',
        message_content_id,
        preview_count,
        filters,
    ],
    formulaMessageCountUpdate: (formulaId: number) => [
        'formula-message-count',
        formulaId,
    ],
    formulaCatalog: (status: FormulaCategory, formulaType?: FormulaType) => [
        ...formulaKeys.all,
        formulaType,
        status,
    ],
    formulaFetchAll: (formulaType?: FormulaType) => [
        'formulaFetchAll',
        formulaType,
    ],
    formulaCatalogCount: (includeControlledFormula?: boolean) => [
        ...formulaKeys.all,
        'catalogCount',
        ...(includeControlledFormula !== undefined
            ? [includeControlledFormula]
            : []),
    ],
    formulaLabelAlternateCount: (formulaId: number) => [
        ...formulaKeys.all,
        formulaId,
        'labelAlternateCount',
    ],
    uniqueMessages: (messageType: FormulaType) => [
        ...formulaKeys.all,
        'unique_messages',
        messageType,
    ],
    surfaceFormulas: (params?: FormulaQueryParam) => [
        ...formulaKeys.all,
        'surfaces',
        Object.values(params || {}),
    ],
    formulaMessageContents: (formulaId: number) => [
        'message-contents',
        formulaId,
    ],
};

export default formulaKeys;
